import type { FieldType, IJobIndex } from '@/interfaces'

export class JobIndex implements IJobIndex {
	[key: string]: FieldType
	id: number
	name: string
	jobNumber: string
	eventId: string
	clientId: string
	clientName: string
	clientContact: number
	startDate: Date
	dueDate: Date
	salesTeam: number
	status: string
	probabilityOfSales: string
	timeline: string
	subJobCount: number

	constructor({
		id,
		name,
		jobNumber,
		eventId,
		clientId,
		clientName,
		clientContact,
		startDate,
		dueDate,
		salesTeam,
		status,
		probabilityOfSales,
		timeline,
		subJobCount
	}: IJobIndex) {
		this.id = id
		this.name = name
		this.jobNumber = jobNumber
		this.eventId = eventId
		this.clientId = clientId
		this.clientName = clientName
		this.clientContact = clientContact
		this.startDate = startDate
		this.dueDate = dueDate
		this.salesTeam = salesTeam
		this.status = status
		this.probabilityOfSales = probabilityOfSales
		this.timeline = timeline
		this.subJobCount = subJobCount
	}
}
